import { z, ZodSchema } from "zod/v4";

import { DatasetId } from "./base";

const MetricsSchema = z.object({
  VARIATION_NAME: z.string().nullish(),
  label: z.string().nullish(),
});

export const MetricSchema = z.record(
  z.string(),
  z.union([z.string(), z.number()])
);
export type MetricType = z.infer<typeof MetricSchema>;

export const MetricArraySchema = MetricSchema.array().default([]);
export type MetricArrayType = z.infer<typeof MetricArraySchema>;

const MetricsWithStatSigSchema = MetricsSchema.extend({
  conversion_best: z.number().nullish(),
  conversion_beat_control: z.number().nullish(),
  average_order_value_best: z.number().nullish(),
  average_order_value_beat_control: z.number().nullish(),
  value_per_visitor_best: z.number().nullish(),
  value_per_visitor_beat_control: z.number().nullish(),
});

const OverviewMetricsModel = MetricsWithStatSigSchema.extend({
  VISITORS: z.number().int().nullish(),
  ORDERS: z.number().int().nullish(),
  TOTAL_PRODUCT_REVENUE: z.number().nullish(),
  TOTAL_PRODUCT_COGS: z.number().nullish(),
  TOTAL_PRODUCT_PROFIT: z.number().nullish(),
  TOTAL_PRODUCT_MARGIN: z.number().nullish(),
  TOTAL_SHIPPING_REVENUE: z.number().nullish(),
  TOTAL_SHIPPING_COST: z.number().nullish(),
  TOTAL_SHIPPING_PROFIT: z.number().nullish(),
  TOTAL_SHIPPING_MARGIN: z.number().nullish(),
  TRANSACTION_FEE: z.number().nullish(),
  TOTAL_REVENUE: z.number().nullish(),
  TOTAL_COST: z.number().nullish(),
  TOTAL_PROFIT: z.number().nullish(),
  TOTAL_MARGIN: z.number().nullish(),
  PROFIT_PER_VISITOR: z.number().nullish(),
  PROFIT_PER_ORDER: z.number().nullish(),
  PRODUCT_REVENUE_WITHOUT_COGS: z.number().nullish(),
  CVR: z.number().nullish(),
  REV_PER_VISITOR: z.number().nullish(),
  AVG_PRODUCT_REVENUE_PER_ORDER: z.number().nullish(),
  AVG_SHIPPING_REVENUE_PER_ORDER: z.number().nullish(),
  AOV: z.number().nullish(),
  AVG_UNITS_PER_ORDER: z.number().nullish(),
  AVG_PRODUCT_REV_PER_UNIT: z.number().nullish(),
  ATC_RATE: z.number().nullish(),
  BEGIN_CHECKOUT_RATE: z.number().nullish(),
});
export type OverviewMetricsModelType = z.infer<typeof OverviewMetricsModel>;

export const BaseTinybirdMetricDetailsSchema = z.object({
  value: z.number().nullish(),
  plus_minus: z.number().nullish(),
  p2bb: z.number().nullish(),
  p2bc: z.number().nullish(),
  ci_low: z.number().nullish(),
  ci_high: z.number().nullish(),
});

export type BaseTinybirdMetricDetailsType = z.infer<
  typeof BaseTinybirdMetricDetailsSchema
>;

export const BaseTinybirdMetricsSchema = z.any();

//   z.object({
//   conversion_rate: BaseTinybirdMetricDetailsSchema.optional(),
//   add_to_cart_rate: BaseTinybirdMetricDetailsSchema.optional(),
//   checkout_begin_rate: BaseTinybirdMetricDetailsSchema.optional(),
//   view_product_page_rate: BaseTinybirdMetricDetailsSchema.optional(),
//   view_collection_page_rate: BaseTinybirdMetricDetailsSchema.optional(),
//   checkout_enter_contact_info: BaseTinybirdMetricDetailsSchema.optional(),
//   checkout_address_submit_rate: BaseTinybirdMetricDetailsSchema.optional(),
//   n_orders: BaseTinybirdMetricDetailsSchema.optional(),
//   n_visitors: BaseTinybirdMetricDetailsSchema.optional(),
//   net_revenue: BaseTinybirdMetricDetailsSchema.optional(),
//   net_revenue_per_visitor: BaseTinybirdMetricDetailsSchema.optional(),
//   net_product_revenue_per_order: BaseTinybirdMetricDetailsSchema.optional(),
//   net_shipping_revenue_per_order: BaseTinybirdMetricDetailsSchema.optional(),
//   avg_units_per_order: BaseTinybirdMetricDetailsSchema.optional(),
//   avg_product_revenue_per_unit: BaseTinybirdMetricDetailsSchema.optional(),
//   pct_discounted_orders: BaseTinybirdMetricDetailsSchema.optional(),
//   n_orders_discounted: BaseTinybirdMetricDetailsSchema.optional(),
//   avg_discount_per_discounted_order: BaseTinybirdMetricDetailsSchema.optional(),
//   avg_discount_per_all_orders: BaseTinybirdMetricDetailsSchema.optional(),
//   discount_pct_total_gross_revenue: BaseTinybirdMetricDetailsSchema.optional(),
//   discount_pct_total_gross_profit: BaseTinybirdMetricDetailsSchema.optional(),
//   discount_pct_discounted_order_gross_profit:
//     BaseTinybirdMetricDetailsSchema.optional(),
//   discount_pct_discounted_order_gross_revenue:
//     BaseTinybirdMetricDetailsSchema.optional(),
//   net_product_revenue: BaseTinybirdMetricDetailsSchema.optional(),
//   total_cogs: BaseTinybirdMetricDetailsSchema.optional(),
//   product_profit: BaseTinybirdMetricDetailsSchema.optional(),
//   net_shipping_revenue: BaseTinybirdMetricDetailsSchema.optional(),
//   total_shipping_cost: BaseTinybirdMetricDetailsSchema.optional(),
//   shipping_profit: BaseTinybirdMetricDetailsSchema.optional(),
//   total_transaction_fee: BaseTinybirdMetricDetailsSchema.optional(),
//   total_cost: BaseTinybirdMetricDetailsSchema.optional(),
//   total_profit: BaseTinybirdMetricDetailsSchema.optional(),
//   gross_margin_pct: BaseTinybirdMetricDetailsSchema.optional(),
//   profit_per_visitor: BaseTinybirdMetricDetailsSchema.optional(),
//   profit_per_order: BaseTinybirdMetricDetailsSchema.optional(),
//   pct_orders_free_shipping: BaseTinybirdMetricDetailsSchema.optional(),
//   subscription_orders_per_visitor: BaseTinybirdMetricDetailsSchema.optional(),
//   subscription_revenue_per_visitor: BaseTinybirdMetricDetailsSchema.optional(),
//   subscription_profit_per_visitor: BaseTinybirdMetricDetailsSchema.optional(),
//   pct_subscription_orders: BaseTinybirdMetricDetailsSchema.optional(),
//   subscription_product_revenue_per_unit:
//     BaseTinybirdMetricDetailsSchema.optional(),
//   subscription_units_per_subscription_order:
//     BaseTinybirdMetricDetailsSchema.optional(),
//   subscription_shipping_revenue_per_order:
//     BaseTinybirdMetricDetailsSchema.optional(),
//   subscription_product_revenue_per_order:
//     BaseTinybirdMetricDetailsSchema.optional(),
//   variation_id: z.uuid(),
//   dt: z.string().optional(), // for time series
//   audience: z.string().optional(),
// });

export type BaseTinybirdMetricsType = z.infer<typeof BaseTinybirdMetricsSchema>;

export const DatasetMap: Record<DatasetId, ZodSchema> = {
  ordersExport: z.any(),
  lineItemsExport: z.any(),
  ordersReconciliation: z.any(),
  ordersReconciliationExport: z.any(),
  ordersReconciliationReasons: z.any(),
  aiProfit: z.any(),
  variation_overview: BaseTinybirdMetricsSchema.array(),
  variation_audience: BaseTinybirdMetricsSchema.array(),
  variation_timeseries_cumulative: BaseTinybirdMetricsSchema.array(),
  variation_timeseries_discrete: BaseTinybirdMetricsSchema.array(),
  experience_countries: z.any(),
  variation_shipping_method: z.any(),
  variation_histogram: z.any(),
  variation_product_groups: z.any(),
  variation_products: z.any(),
  variation_order_unit_mix: z.any(),
  custom_events_plugin: z.any(),
  custom_events_server: z.any(),
  order_reconciliation: z.any(),
  order_reconciliation_export: z.any(),
  profit: z.any(),
  country_codes: z.any(),
};
